import {Injectable, signal} from "@angular/core";
import {FirebaseAnalytics} from "@capacitor-community/firebase-analytics";
import {FirebaseEventEnum, FirebaseValue} from "../enum/firebase-event.enum";
import {CommonService} from "./common.service";
import {environment} from "../../../environments/environment";
import {Platform} from "@ionic/angular";
import {initializeApp} from 'firebase/app';
import {getAnalytics} from "firebase/analytics";
import {logEvent} from "firebase/analytics";
import { Preferences } from '@capacitor/preferences';

export interface ConsentState {
  analytics: boolean;
  hasAnswered: boolean; // per sapere se mostrare la modale o meno
}

const CONSENT_KEY = 'user_consent_v1';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  // signal accessibile ovunque nell'app, sincrono, reattivo
  consent = signal<ConsentState>({ analytics: false, hasAnswered: false });

  private analytics;

  constructor(private commonService: CommonService,
              private platform: Platform) {
  }

  init() {
    if (this.platform.is('mobileweb')) {
      this.initWeb();
    } else {
      this.iniDevice();
    }
  }

  disable(){
    FirebaseAnalytics.disable().catch();
  }

  logEvent(name: FirebaseEventEnum, params = {}) {

    if (!this.hasAnalyticsConsent()) return;

    params['profile_type'] = this.commonService?.profileType;

    console.warn(`[FirebaseAnalytics.logEvent] ${name}`, params);

    if (this.commonService.isMobile()) {
      try {

        FirebaseAnalytics.logEvent({
          name,
          params
        }).catch();

      } catch (error) {
        console.error(error);
      }
    } else {

      try {
        if (this.analytics) {
          logEvent(this.analytics, name, params);
        } else {
          console.warn('Firebase analytics non inizializzato per il web');
        }
      } catch (error) {
        console.error('Errore Firebase (web):', error);
      }

    }

  }

  iniDevice() {
    if (environment.production) {
      console.log("FirebaseAnalytics.enable()");
      FirebaseAnalytics.enable().catch();
    } else {
      console.log("FirebaseAnalytics.disable()");
      FirebaseAnalytics.disable().catch();
    }
  }

  initWeb() {
    const firebaseConfig = {
      apiKey: "AIzaSyArSsaCExaNFZqvOEKQ1Ws3u-fxwFlrsE8",
      authDomain: "andriasmart-3a9e3.firebaseapp.com",
      projectId: "andriasmart-3a9e3",
      storageBucket: "andriasmart-3a9e3.appspot.com",
      messagingSenderId: "689668954648",
      appId: "1:689668954648:web:5fd9129f8e4cc47c0ec16d",
      measurementId: "G-6Q7GFPBP1R"
    };

    const app = initializeApp(firebaseConfig);

    if (typeof window !== "undefined" && environment.production) {
      this.analytics = getAnalytics(app);
    }
  }

  trackPageNameEvent(pageName: FirebaseValue) {
    this.logEvent(FirebaseEventEnum.PAGE_NAME, {
      page_name: pageName,
    });
  }

  trackPageNameEventByString(page_name: string) {
    this.logEvent(FirebaseEventEnum.PAGE_NAME, {
      page_name,
    });
  }

  async loadConsent(): Promise<void> {
    const { value } = await Preferences.get({ key: CONSENT_KEY });

    if (value) {
      this.consent.set(JSON.parse(value));
    } else {
      this.consent.set({ analytics: false, hasAnswered: false });
    }
  }

  async setConsent(analytics: boolean): Promise<void> {
    const newState: ConsentState = { analytics, hasAnswered: true };
    this.consent.set(newState);
    await Preferences.set({
      key: CONSENT_KEY,
      value: JSON.stringify(newState)
    });
  }

  hasAnalyticsConsent(): boolean {
    return this.consent().analytics;
  }

  shouldShowConsentModal(): boolean {
    return !this.consent().hasAnswered;
  }

}
